module.exports = __webpack_public_path__ + "campaign/partner2021-minisite-1/img/applet2.cff7450f.png";